import React from 'react';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XXL, MD, LG } from '@zendeskgarden/react-typography';
import { ItemCol, ItemRow } from './SteelPannelShielding.styles.js';
import { Dot, Reason } from 'components/ChooseOurCompany/ChooseOurCompany.styles.js';
import ImageGrid from 'components/ImageGrid/ImageGrid'


const CopperShielding = (props) => {
  return (
    <div style={{margin: '0 auto', maxWidth: '1100px'}}>
      <Row>
        <Col size="12" style={{marginBottom: '40px'}}>
          <div>
            <XXL bold  style={{margin: '0 auto', maxWidth: '600px'}} center paddingTopLg navy tag="h2">Galvanized Steel Panel RF Shielding</XXL>
            <LG center style={{margin: '0 auto', maxWidth: '700px'}} paddingTopMd paddingBottomLg navy light tag="h3">Our materials and construction techniques make use of the wisest choices in every category. The copper material has been carefully selected and tested to provide maximum durability and flexibility to meet challenging geometries.  </LG>
          </div>
        </Col>
      </Row>
      
      <ItemRow>
        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Copper RF Shield Wall</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">
              The copper is 100% adhered to a 3/4" substrate which provides robustness and adaptability for easy modifications. All penetrations are carefully controlled with stainless steel hardware. Installation of interior furring is provided and no wood products are utilized in the floor system.
            </MD>

          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Copper RF Shield Ceiling</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">
              The copper is 100% adhered to a 3/4" substrate which provides robustness and adaptability for easy modifications. All penetrations are carefully controlled with stainless steel hardware. Installation of interior furring is provided and no wood products are utilized in the floor system.ime. 
            </MD>
          </div>
        </ItemCol>


        <ItemCol size="12" md={12} style={{marginBottom: '30px'}}>
          <div>
            <MD uppercase paddingTopMd semibold blue tag="h3">Copper RF Shield Floor</MD>
            <MD paddingBottomMd paddingTopMd slate light tag="h3">
              The copper is 100% adhered to a 3/4" substrate which provides robustness and adaptability for easy modifications. All penetrations are carefully controlled with stainless steel hardware. Installation of interior furring is provided and no wood products are utilized in the floor system.
            </MD>
          </div>
        </ItemCol>

      </ItemRow>




    {/*  <ItemRow>
        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold navy tag="h3">Advantages</MD>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>

          </div>
        </ItemCol>


        <ItemCol size="12" md={6}>
          <div>
            <MD uppercase paddingTopMd semibold navy tag="h3">Disadvantages</MD>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>
            <Reason><Dot></Dot><MD navy>Our company’s focus is to do things right, the first time. </MD></Reason>

          </div>
        </ItemCol>
      </ItemRow>
*/}

      <ItemRow  style={{marginTop: '30px'}}>
        <ItemCol size="12" md={12}>
          <div>
            <ImageGrid images={[{image: 'https://live.staticflickr.com/8088/8551381229_b08472d6e9_z.jpg'}, {image: 'https://live.staticflickr.com/5349/10256826223_bb40004c7d_z.jpg'}, {image: 'https://live.staticflickr.com/3737/10256715325_bf3abe48b7_z.jpg'}]} />
          </div>
        </ItemCol>
      </ItemRow>


    </div>
  )
}


export default CopperShielding;
